<template>
	<div>
		<h2>{{ $t('base.profile.synchronization') }}</h2>
		<p>Interval to synchronize readings, in seconds.</p>
		<input-text v-model="interval" name="interval" placeholder="Interval"/>
	</div>
</template>

<script>
import * as mutations from '@/store/modules/mutations'
export default {
	computed: {
		interval: {
			get () {
				return '' + this.$store.state.user.syncReadings
			},
			set (value) {
				this.$store.commit(mutations.SET_USER_SYNC, parseInt(value))
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Synchronization')
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/Synchronization.vue